@if (fileEditModel.isInitialLoad && loading) {
  <app-loader></app-loader>
}
@if (!ingestionLoadData) {
  <div class="row no-load-data mt-3">
    <div class="col-12 d-flex flex-column align-items-center justify-content-center text-center">
      <i class="icon-error-report main"></i>
      <h4 class="w-75">Load information is not available. Please click on the view icon ( <i
      class="fas fa-file-alt hvr-shrink fa-lg cursor-pointer text-yellow"></i> ) in the 'Data Load' page to
    view the form.</h4>
  </div>
</div>
}
@if (ingestionLoadData) {
  <div>
    <div class="row mb-3">
      <div class="col-12 d-flex align-items-center">
        <div class="text-center color-teal d-flex align-items-center ">
          <p class="mb-0 font-weight-bold">File Name : </p>
          <p class="mb-0 ml-2 form-data">{{ingestionLoadData.fileName}}</p>
        </div>
        <div class="text-center color-teal d-flex align-items-center ml-5">
          <p class="mb-0 font-weight-bold">Report Pack Name : </p>
          <p class="mb-0 ml-2 form-data">{{ingestionLoadData.reportpacktitle}}</p>
        </div>
        <div class="text-center color-teal d-flex align-items-center ml-5">
          <p class="mb-0 font-weight-bold">Reporting Period : </p>
          <p class="mb-0 ml-2 form-data">{{ingestionLoadData.reportingperiod | date: 'dd/MM/yyyy'}}</p>
        </div>
        <div class="text-center color-teal d-flex align-items-center ml-5">
          <button class="btn btn-primary-ey btn-icon small-font hvr-shrink" type="button"
            (click)="openReportRunPopUp(reportRunPopUp)">
            <div class="icon-container"><i class="fa fa-check-square fa-lg"></i></div><span>Report Run</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      @if (dataPrepInProgress) {
        <h6 class="text-white-50 font-italic small-font mt-3"><i
        class="fas fa-exclamation-triangle hvr-shrink failed-icon mr-3"></i>Data preparation is in progress for
        the report pack. Please save as draft and submit your changes after data preparation is complete for the
        report pack!
      </h6>
    }
  </div>
  @if (gridColumns) {
    <div class="row">
      <kendo-grid class="ingestion-grid-centered" [data]="gridData" scrollable="scrollable" style="width: 100%" [loading]="loading" [height]="450"
        (remove)="removeRow($event)" [resizable]="true" [pageSize]="pageSize" [skip]="skip" [pageable]="true"
        (pageChange)="pageChange($event)">
        <ng-template kendoGridToolbarTemplate>
          <button class="k-button float-right" (click)="openPopUp(summaryPopUp, 'm')">
            <i class="fas fa-book-open fa-lg" ngbTooltip="Summary"></i>
          </button>
          <button class="k-button float-right" (click)="openPopUp(sortPopUp, 'lg')">
            <i class="fas fa-sort fa-lg" ngbTooltip="Sort"></i>
          </button>
          <button class="k-button float-right" (click)="openPopUp(filterPopUp, 'xl')">
            <i class="fas fa-filter fa-lg" ngbTooltip="Filter"></i>
          </button>
        </ng-template>
        <kendo-grid-command-column title="Actions" width="120px" [locked]="true">
          <ng-template kendoGridCellTemplate >
            <button class="icon-button hvr-shrink icon-trash" kendoGridRemoveCommand><i
            class="fas fa-trash-alt fa-sm my-1"></i></button>
          </ng-template>
        </kendo-grid-command-column>
        <kendo-grid-column field="status" title="Status" width="120" [locked]="true">
          <ng-template kendoGridCellTemplate let-dataItem>
            @if (dataItem.status == 'Error') {
              <i class="fas fa-exclamation-circle fa-lg text-danger"></i>
            }
            @if (dataItem.status == 'Success') {
              <i class="fas fa-check-circle fa-lg text-success"></i>
            }
            @if (dataItem.status == 'Draft') {
              <i class="fas fa-pen-fancy fa-lg text-warning"></i>
            }
            @if (dataItem.status == 'Valid') {
              <i class="fas fa-check-circle fa-lg text-warning"></i>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="rowRefId" title="IRR Internal ID" width="100" [locked]="true" [editable]="false">
        </kendo-grid-column>
        @for (c of gridColumns; track c) {
          <kendo-grid-column [id]="c.columnId" [field]="c.field" [editable]="c.editable"
            [title]="c.title" format="{0:n}" [locked]="c.pinned" [hidden]="c.hidden" width="120px"
            [class]="{'k-grid-align-left': c.leftalign, 'k-grid-align-right': c.rightalign, 'k-grid-align-center': c.centeralign}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <div class="d-flex align-items-center justify-content-center">
                <div class="col-12 p-0 text-truncate"
                            [ngClass]="[errorCells.indexOf(dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId) > -1 && localDraftCells.indexOf(dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId) == -1 ? 'error-cell': '', 
                        draftCells.indexOf(dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId) > -1 && localDraftCells.indexOf(dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId) == -1 ? 'draft-cell': '',
                        localDraftCells.indexOf(dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId) > -1 ? 'local-draft': '', c.editable ? 'editable': '']"
                            (dblclick)="showEditPopUp(cellPopOutModal, dataItem, c)"
                            title="{{errorCells.indexOf(dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId) > -1 
                            && localDraftCells.indexOf(dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId) == -1 
                            && cellErrorMessageJson[dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId] ? cellErrorMessageJson[dataItem.rowRefId +'_'+ dataItem.clientRefId + '_' + c.columnId] : ''}}">
                  <div class="cell-data-padding">{{dataItem[c.field]}}</div>
                </div>
              </div>
            </ng-template>
          </kendo-grid-column>
        }
      </kendo-grid>
      <div class="row float-right" [ngStyle]="{'padding-left': '15px'}">
        <button class="btn btn-primary-ey btn-icon mb-2 hvr-shrink small-font form-btn" type="button"
          (click)='backToIngestion()'>
          <div class="icon-container"><i class="fas fa-arrow-left fa-lg"></i></div><span>Back
          to
        Ingestion</span>
      </button>
      <button class="btn btn-primary-ey btn-icon mb-2 hvr-shrink small-font form-btn" type="button"
        (click)='downloadErrorAuditReport()'>
        <div class="icon-container hvr-shrink"><i class="fas fa-lg fa-download"></i></div>
        <span>Download Error Audit</span>
      </button>
      <button class="btn btn-primary-ey btn-icon mb-2 hvr-shrink small-font form-btn" type="button"
        (click)='downloadAuditReport()'>
        <div class="icon-container hvr-shrink"><i class="fas fa-lg fa-download"></i></div>
        <span>Download Audit</span>
      </button>
      <button class="btn btn-primary-ey btn-icon mb-2 hvr-shrink small-font form-btn" type="button"
        (click)="saveIngestionForm(true)">
        <div class="icon-container hvr-shrink"><i class="fas fa-lg fa-save"></i></div>
        <span>Save As Draft</span>
      </button>
      <button class="btn btn-primary-ey btn-icon mb-2 hvr-shrink small-font form-btn" type="button"
        (click)="saveIngestionForm(false)">
        <div class="icon-container hvr-shrink"><i class="fas fa-lg fa-thumbs-up"></i></div>
        <span>Submit Form</span>
      </button>
      <button class="btn btn-primary-ey btn-icon mb-2 hvr-shrink small-font form-btn" type="button"
        (click)="undoChanges()">
        <div class="icon-container hvr-shrink"><i class="fas fa-lg fa-undo"></i></div>
        <span>Undo All Changes</span>
      </button>
    </div>
  </div>
}
</div>
}
<ng-template #sortPopUp let-modal>
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">Custom Sort<i
      class="fas fa-times ml-auto cursor-pointer" aria-label="Close"
    (click)="cancelSortChanges();modal.close()"></i></h5>
  </div>
  <div class="modal-body">
    <h6 class="text-white-50  font-italic small-font mt-3"><i class="fas fa-info-circle text-yellow mr-3"></i>Please
  click on the cell under columns 'Column' and 'Sort Order' to open the editor.</h6>
  <kendo-grid [data]="sortPopUpModel" scrollable="scrollable" [sortable]="false" [resizable]="true"
    [pageable]="false" (cellClick)="sortGridCellClickHandler($event)"
    (cellClose)="sortGridCellCloseHandler($event)" (remove)="removeSortLevel($event)"
    (add)="addSortLevel($event)">
    <ng-template kendoGridToolbarTemplate class="k-grid-toolbar">
      <button class="add-button hvr-shrink" kendoGridAddCommand>Add Level</button>
    </ng-template>
    <kendo-grid-column field="sortLevelText" title="" width="120" [editable]="false"></kendo-grid-column>
    <kendo-grid-column field="columnText" title="Column" width="140">
      <ng-template kendoGridEditTemplate let-formGroup>
        <div>
          <select [(ngModel)]="formGroup.value['columnId']">
            @for (op of sortColumnList; track op) {
              <option [ngValue]="op.columnId">
              {{op.title}}</option>
            }
          </select>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="sortOrderText" title="Sort Order" width="120">
      <ng-template kendoGridEditTemplate let-formGroup>
        <div>
          <select [(ngModel)]="formGroup.value['sortOrder']">
            @for (op of sortOrderOptions; track op) {
              <option [ngValue]="op.sortOrder">
              {{op.sortOrderText}}</option>
            }
          </select>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-command-column title="Actions" width="100">
      <ng-template kendoGridCellTemplate>
        <button class="icon-button hvr-shrink icon-trash" kendoGridRemoveCommand><i
        class="fas fa-trash-alt fa-sm my-1"></i></button>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
</div>
<div class="modal-footer">
  <div class="float-right m-0">
    <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button"
      (click)='cancelSortChanges();modal.close()'>
      <span>Cancel</span>
    </button>
    <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button"
      (click)='clearSortSelection();modal.close()'>
      <span>Clear</span>
    </button>
    <button class="btn btn-modal-pos small-font hvr-shrink" type="button"
      (click)="confirmSortSelection();modal.close()">
      <span>Submit</span>
    </button>
  </div>
</div>

</ng-template>
<ng-template #filterPopUp let-modal>
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">Custom Filter<i
      class="fas fa-times ml-auto cursor-pointer" aria-label="Close"
    (click)="modal.close();cancelFilterChanges();"></i></h5>
  </div>
  <div class="modal-body">
    <div class="row">
      Show Only Error Rows :
      <kendo-switch [(ngModel)]="showOnlyErrorRows" onLabel="Yes" offLabel="No"></kendo-switch>
    </div>
    <div class="row">
      <kendo-grid [kendoGridBinding]="filterPopUpModel" scrollable="'scrollable'" [sortable]="true"
        [resizable]="true" style="width: 100%" [height]="670" [pageable]="false" [filterable]="true">
        <kendo-grid-column field="title" title="Column" width="120" editable="false"></kendo-grid-column>
        <kendo-grid-column field="showColumn" title="Show Column" width="120" filter="boolean">
          <kendo-grid-messages filterIsTrue="Yes" filterIsFalse="No"></kendo-grid-messages>
          <ng-template kendoGridCellTemplate let-dataItem>
            <div>
              <kendo-switch [(ngModel)]="dataItem['showColumn']" onLabel="Yes" offLabel="No"
                [disabled]="dataItem.disableShowColumnChange">
              </kendo-switch>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="enableFilter" title="Enable Filter" width="120" filter="boolean">
          <kendo-grid-messages filterIsTrue="Yes" filterIsFalse="No"></kendo-grid-messages>
          <ng-template kendoGridCellTemplate let-dataItem>
            <div>
              <kendo-switch [(ngModel)]="dataItem['enableFilter']" onLabel="Yes" offLabel="No"
                (valueChange)="onFilterSwitchChange($event, dataItem)">
              </kendo-switch>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="filterType" title="Filter Type" width="150px" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            @if (dataItem['enableFilter']) {
              <div>
                <select [(ngModel)]="dataItem['filterType']">
                  @for (op of dataItem.filterTypeOptions; track op) {
                    <option [ngValue]="op">
                    {{op}}</option>
                  }
                </select>
              </div>
            }
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="value" title="Filter Value" width="500px" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            @if (dataItem['enableFilter']) {
              <div>
                @if (dataItem.columnType == 'numeric') {
                  <kendo-numerictextbox
                    [(ngModel)]="dataItem.numberValue" [decimals]="5" [autoCorrect]="true"
                    [min]="-1000000000000000" [max]="1000000000000000" [format]="'n'">
                  </kendo-numerictextbox>
                }
                @if (dataItem.columnType == 'text' && dataItem.filterType == 'Contains') {
                  <input
                    [(ngModel)]="dataItem.textValue" maxlength="50" />
                }
                @if (dataItem.columnType == 'text' && dataItem.filterType == 'Dictionary') {
                  <kendo-multiselect
                    [data]="dataItem.dictionary" [(ngModel)]="dataItem.dictionarySelection"
                  [textField]="'acceptableValue'" [valueField]="'mappingValue'"></kendo-multiselect>
                }
                @if (dataItem.columnType == 'boolean') {
                  <select [(ngModel)]="dataItem['booleanValue']">
                    @for (op of dataItem.dictionary; track op) {
                      <option [ngValue]="op.value">
                      {{op.title}}</option>
                    }
                  </select>
                }
                @if (dataItem.columnType == 'date') {
                  <input [style.display]="'none'" />
                }
                @if (dataItem.columnType == 'date' && dataItem.filterType == 'Range') {
                  <p-datepicker
                    [(ngModel)]="dataItem.dateLowerLimit" [showIcon]="true" [autoZIndex]="true"
                    dateFormat="dd/mm/yy" [readonlyInput]="true" [monthNavigator]="true"
                    yearRange="{{yearRange}}" [yearNavigator]="true">
                  </p-datepicker>
                }
                @if (dataItem.columnType == 'date' && dataItem.filterType == 'Range') {
                  <p-datepicker
                    [(ngModel)]="dataItem.dateUpperLimit" [showIcon]="true" [autoZIndex]="true"
                    dateFormat="dd/mm/yy" [readonlyInput]="true" [monthNavigator]="true"
                    yearRange="{{yearRange}}" [yearNavigator]="true">
                  </p-datepicker>
                }
                @if (dataItem.columnType == 'date' && dataItem.filterType != 'Range') {
                  <p-datepicker
                    [(ngModel)]="dataItem.dateValue" [showIcon]="true" [autoZIndex]="true"
                    dateFormat="dd/mm/yy" [readonlyInput]="true" [monthNavigator]="true"
                    yearRange="{{yearRange}}" [yearNavigator]="true">
                  </p-datepicker>
                }
              </div>
            }
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
  <div class="modal-footer">
    <div class="float-right m-0">
      <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button"
        (click)='modal.close();cancelFilterChanges()'>
        <span>Cancel</span>
      </button>
      <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button"
        (click)='clearFilterSelection();'>
        <span>Reset Filters</span>
      </button>
      <button class="btn btn-modal-pos small-font hvr-shrink" type="button"
        (click)="modal.close();confirmFilterSelection();">
        <span>Submit</span>
      </button>
    </div>
  </div>

</ng-template>

<ng-template #cellPopOutModal let-modal>
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">Update<i class="fas fa-times ml-auto cursor-pointer"
    aria-label="Close" (click)="cellPopOutClose()"></i></h5>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-8">
        <form class="material-styling w-100 mt-3" #cellPopOutForm="ngForm">
          @if (cellPopOutModel != null) {
            <div>
              <div class="row">
                <div class="col-3">
                  <div class="group">
                    <input type="text" value="{{cellPopOutModel.clientRefId}}" required disabled />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="non-input-label">Reference Id</label>
                  </div>
                </div>
                <div class="col-3">
                  <div class="group">
                    <input type="text" value="{{cellPopOutModel.columnTitle}}" class="text-truncate"
                      title="{{cellPopOutModel.columnTitle}}" required disabled />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="non-input-label">Column</label>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="group">
                      <input type="text" value="{{cellPopOutModel.oldValue}}" required disabled />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label class="non-input-label">Cell Value</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="color-teal font-14 mb-2">
                      New Value<sup><i class="fas fa-asterisk text-danger fa-xs ml-1"></i></sup>
                    </div>
                    <div>
                      @if (cellPopOutModel.cellOptions.length == 0 && cellPopOutModel.editor == 'numeric') {
                        <kendo-numerictextbox
                          required id="cellPopOutNewValue" name="cellPopOutNewValue"
                          [(ngModel)]="cellPopOutModel.newValue" [decimals]="cellPopOutModel.decimals"
                          [autoCorrect]="true" [min]="-1000000000000000" [max]="1000000000000000"
                          [format]="'n'" class="w-100">
                        </kendo-numerictextbox>
                      }
                      @if (cellPopOutModel.cellOptions.length == 0 && cellPopOutModel.editor == 'text') {
                        <input type="text"
                          id="cellPopOutNewValue" name="cellPopOutNewValue" required
                          [(ngModel)]="cellPopOutModel.newValue" maxlength="50"
                          pattern="^[A-Za-z0-9 _\-.]*$" trim-text class="w-100 cellPopOutInput" />
                      }
                      @if (cellPopOutModel.cellOptions.length == 0 && cellPopOutModel.editor == 'date') {
                        <input
                          [style.display]="'none'" />
                      }
                      @if (cellPopOutModel.cellOptions.length == 0 && cellPopOutModel.editor == 'date') {
                        <p-datepicker
                          id="cellPopOutNewValue" name="cellPopOutNewValue" required
                          [(ngModel)]="cellPopOutModel.newValue" [showIcon]="true" [autoZIndex]="true"
                          dateFormat="dd/mm/yy" [readonlyInput]="true" [monthNavigator]="true"
                          yearRange="{{yearRange}}" [yearNavigator]="true">
                        </p-datepicker>
                      }
                      @if (cellPopOutModel.cellOptions.length > 0) {
                        <select class="w-100 cellPopOutInput"
                          required [(ngModel)]="cellPopOutModel.newValue" id="cellPopOutNewValue"
                          name="cellPopOutNewValue">
                          @for (op of cellPopOutModel.cellOptions; track op) {
                            <option [ngValue]="op.value">
                            {{op.title}}</option>
                          }
                        </select>
                      }
                      @if (cellPopOutModel.oldValue == cellPopOutModel.newValue) {
                        <div
                          class="alert alert-danger">
                          New value cannot be same as old value. Please enter a different value
                        </div>
                      }
                      @if (!cellPopOutForm.valid && cellPopOutForm.controls.cellPopOutNewValue.errors) {
                        <div
                          class="alert alert-danger">
                          @if (cellPopOutForm.controls.cellPopOutNewValue.errors.required) {
                            <div>
                              Please enter a value to save changes.
                            </div>
                          }
                          @if (cellPopOutForm.controls.cellPopOutNewValue.errors.maxError || cellPopOutForm.controls.cellPopOutNewValue.errors.minError) {
                            <div
                              >
                              The value should be between -1,000,000,000,000,000 and
                              1,000,000,000,000,000.
                            </div>
                          }
                          @if (cellPopOutForm.controls.cellPopOutNewValue.errors.pattern) {
                            <div>
                              The value contains invalid characters.
                            </div>
                          }
                          @if (cellPopOutForm.controls.cellPopOutNewValue.errors.maxlength) {
                            <div>
                              The value cannot be greater than 50 characters.
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="color-teal font-14 mb-2">
                      Comment<sup><i class="fas fa-asterisk text-danger fa-xs ml-1"></i></sup>
                    </div>
                    <div>
                      <textarea id="cellPopOutComment" name="cellPopOutComment" required maxlength="500"
                        #cellPopOutComment="ngModel" rows="4" [(ngModel)]="cellPopOutModel.comment"
                      pattern="^[A-Za-z0-9 _\-.]*$" trim-text placeholder="Enter Comments" class="w-100 cellPopOutInput"></textarea>
                      @if (!cellPopOutForm.valid && cellPopOutForm.controls.cellPopOutComment.errors) {
                        <div
                          class="alert alert-danger">
                          @if (cellPopOutForm.controls.cellPopOutComment.errors.required && cellPopOutForm.controls.cellPopOutComment.touched) {
                            <div
                              >
                              Please enter a comment to save changes.
                            </div>
                          }
                          @if (cellPopOutForm.controls.cellPopOutComment.errors.pattern) {
                            <div>
                              The comment contains invalid characters.
                            </div>
                          }
                          @if (cellPopOutForm.controls.cellPopOutComment.errors.maxlength) {
                            <div>
                              The comment cannot be greater than 500 characters.
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </form>
        </div>
        @if (cellPopOutModel.latestAudit !=null) {
          <div class="col-4 d-flex align-items-center justify-content-center text-center border-left-yellow"
            >
            <div class="p-5">
              <p>This cell was last modified by <span
              class="text-yellow">{{cellPopOutModel.latestAudit.ChangedBy}}</span> on <span
              class="text-yellow">{{cellPopOutModel.latestAudit.ChangedDate | date: 'dd-MM-yyyy
            hh:mm:ss'}}</span>
            and the value was changed
            from <span class="text-yellow">{{cellPopOutModel.latestAudit.OldValue}}</span>
            to
            <span class="text-yellow">{{cellPopOutModel.latestAudit.NewValue | dataTypeFormat :
            cellPopOutModel.editor}}</span>
          </p>
          <span class="cursor-pointer change-log" (click)="getFormCellAudit(cellPopOutModel)">View Change
          Log</span>
        </div>
      </div>
    }
  </div>
  @if (cellAudit && cellAudit.length > 0) {
    <div class="row mt-3">
      <div class="col-12">
        <div class="">
          <p-table #changeLog [paginator]="true" [rows]="12" class="table-irr change-log-table"
            [value]="cellAudit" [columns]="auditTableCols" [scrollable]="true"
            [scrollHeight]="'calc(100vh - 292px)'">
            <ng-template pTemplate="paginatorleft">
              <button class="btn btn-clear-filter hvr-shrink" type="button"
                (click)="changeLog.reset();clearFilters();">
                <span><i class="fas fa-times mr-1"></i> Clear Filters</span>
              </button>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of columns; track col) {
                  <th [pSortableColumn]="col.field"> {{col.header}}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                }
              </tr>
              <tr>
                @for (col of columns; track col) {
                  <th>
                    @if (col.field =='ChangedDate') {
                      <p-datepicker [(ngModel)]="modifiedDateFilters"
                        #clFilter selectionMode="range" [showIcon]="true" dateFormat="dd/mm/yy"
                        [readonlyInput]="true" placeholder="Select a range"
                        [monthNavigator]="true" [yearNavigator]="true" yearRange="{{yearRange}}"
                        (ngModelChange)="changeLog.filter(modifiedDateFilters, col.field, 'dateRangeFilter')"
                      (onSelect)="closeDateRangeFilter(clFilter, modifiedDateFilters)"></p-datepicker>
                    }
                    @if (col.field !='ChangedDate') {
                      <input type="text" class="w-100"
                        placeholder="Filter Text"
                        [value]="changeLog.filters && changeLog.filters[col.field] ? changeLog.filters[col.field].value: ''"
                        (input)="changeLog.filter($event.target.value, col.field, 'contains')">
                    }
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr [ngClass]="{'font-italic': rowData.isSaved == false }">
                <td>{{rowData['oldValue']}}</td>
                <td>{{rowData['newValue'] | dataTypeFormat : cellPopOutModel.editor}}</td>
                <td>{{rowData['comment']}}</td>
                <td>{{rowData['changedBy']}}</td>
                <td>{{rowData['changedDate'] | date: 'dd-MM-yyyy hh:mm:ss'}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <div class="row w-100 m-0">
    <div class="col-6 pl-0">
      <h6 class="mb-0 font-13">
        <sup><i class="fas fa-asterisk text-danger fa-xs mr-1"></i></sup>
        Required fields
      </h6>
      @if (cellAudit && cellAudit.length > 0) {
        <h6 class="mb-0 font-13">
          <span class="text-info">Note : </span>
          Unsaved audit rows will be shown in italics.
        </h6>
      }
    </div>
    <div class="col-6 text-right pr-0">
      <button class="btn btn-modal-neg small-font mr-2 hvr-shrink" type="button" (click)='clearEditPopUp()'>
        <span>Clear</span>
      </button>
      <button class="btn btn-modal-pos small-font hvr-shrink" type="button" (click)="submitCellEdit()"
        [disabled]="!cellPopOutModel.isNullable">
        <span>Delete Cell Data</span>
      </button>
      <button class="btn btn-modal-pos small-font hvr-shrink" type="button"
        [disabled]="(cellPopOutForm && !cellPopOutForm.form.valid) || !isValidForm()"
        (click)="submitCellEdit()">
        <span>Submit</span>
      </button>
    </div>
  </div>
</div>
</ng-template>
<ng-template #summaryPopUp let-modal>
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">Summary<i
    class="fas fa-times ml-auto cursor-pointer" aria-label="Close" (click)="modal.close()"></i></h5>
  </div>
  <div class="modal-body">
    <div class="text-center color-teal d-flex align-items-center ml-5">
      <p class="mb-0 font-weight-bold">Total Row Count : </p>
      <p class="mb-0 ml-2 form-data">{{gridData.total}}</p>
    </div>
    <div class="text-center color-teal d-flex align-items-center ml-5">
      <p class="mb-0 font-weight-bold">Total Error Count : </p>
      <p class="mb-0 ml-2 form-data">{{gridData.totalErrorCount}}</p>
    </div>
    <div class="text-center color-teal d-flex align-items-center ml-5">
      <p class="mb-0 font-weight-bold">Unvalidated Row Count : </p>
      <p class="mb-0 ml-2 form-data">{{gridData.totalDraftRows}}</p>
    </div>
  </div>
</ng-template>
<ng-template #reportRunPopUp let-modal>
  <div class="modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">Report Run
      <i class="fas fa-times ml-auto cursor-pointer" aria-label="Close" (click)="modal.close()"></i>
    </h5>
  </div>
  <div class='modal-body'>
    <app-report-tree [(selectedReports)]="selectedReports" selectDependencies="true"></app-report-tree>
    <div class="float-right">
      <button class="btn btn-modal-pos small-font hvr-shrink" (click)="clearReportSelection()" type="button">
        <span>Clear All</span>
      </button>
      <button class="btn btn-modal-pos small-font hvr-shrink" (click)="submitReportSelection();modal.close();"
        type="button">
        <span>Submit</span>
      </button>
    </div>
  </div>
</ng-template>